import React, { useEffect, useRef } from "react";
import MonetaLogo from "./MonetaLogo";

const FOCUSABLE_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

const Modal = ({ isOpen, setIsOpen }) => {
  const containerRef = useRef(null);
  const previousActiveRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("active-modal");
      previousActiveRef.current = document.activeElement;
      const focusable = containerRef.current?.querySelectorAll(FOCUSABLE_SELECTOR);
      const first = focusable?.[0];
      if (first) first.focus();
    } else {
      document.body.classList.remove("active-modal");
      previousActiveRef.current?.focus?.();
    }
    return () => {
      document.body.classList.remove("active-modal");
      previousActiveRef.current?.focus?.();
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
      if (e.key !== "Tab") return;
      const el = containerRef.current;
      if (!el) return;
      const focusable = [...el.querySelectorAll(FOCUSABLE_SELECTOR)];
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last?.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first?.focus();
        }
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, setIsOpen]);

  const handleClose = () => setIsOpen(false);

  if (!isOpen) return null;

  return (
    <div
      className="_modal"
      ref={containerRef}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        className="overlay"
        onClick={handleClose}
        onKeyDown={(e) => e.key === "Enter" && handleClose()}
        role="button"
        tabIndex={-1}
        aria-label="Close modal"
      />
      <div className="custom-modal-content mx-auto bg-white text-black">
        <MonetaLogo className="cls-1" />
        <p id="modal-title" className="text-lg">
          We are currently working on this page!
        </p>
        <button type="button" className="btn btn-primary" onClick={handleClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default Modal;
